module.exports = __webpack_public_path__ + "img/confetti_1d.ac1284df.svg";